import { Button, ButtonProps } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import LoadingButton from "../../../shared/components/LoadingButton";
import Select from "../../../shared/components/Select";
import SelectNoResults from "../../../shared/components/SelectNoResults";
import useApi from "../../../shared/hooks/useApi";
import { NoteSubjectId } from "../../../shared/schema/schema";

export default function NoteSubjectSelect(props: {
  buttonProps?: ButtonProps;
  value: NoteSubjectId | null;
  onChange: (value: NoteSubjectId | undefined) => void;
}) {
  const { queries } = useApi();
  const query = useQuery(queries.note.settings());

  switch (query.status) {
    case "pending":
      return <LoadingButton />;
    case "error":
      return (
        <Button
          isDisabled={true}
          justifyContent="flex-start"
          variant="outline"
          {...props.buttonProps}
        >
          Failed to render input
        </Button>
      );
    case "success":
      return (
        <Select
          buttonProps={props.buttonProps}
          label="Select subject"
          multiple={false}
          options={query.data.agencyNoteSubjects.map((x) => ({ value: x.id, label: x.text }))}
          renderAfter={({ searchTerm, filteredOptions }) =>
            filteredOptions.length === 0 && <SelectNoResults searchTerm={searchTerm} />
          }
          value={props.value}
          onChange={props.onChange}
        />
      );
  }
}
